/*
    Attach this to any element that stop event progragation, thus preventing from default modal closing,
    i.e. modal-box component
*/
import { Directive, HostListener, } from '@angular/core';

@Directive({
    selector: '[directive-drop-down-outer-click]',
})
export class DropdDownOuterClickDirective {
    @HostListener('click', ['$event']) public onElementClick($event: Event): void {
        window.dispatchEvent(new Event('drop-down:outer-click'));
    }
}
